import { PureComponent, type ReactNode } from "react";
import { type AvailabilityInfo } from "../../../../api/pna/AvailabilityInfo";
import { type PreferredProductData } from "../../../models/PdpPageProductData";
import { requestAvailabilityDataSingle } from "../../../../common/api/availabilityService";
import { selectProductIsInStock } from "../../../../utils/pna/availabilitySelectors";

interface StockDataProviderProps {
  children: (props: StockDataProviderState) => ReactNode;
  products: PreferredProductData[];
}

export interface StockDataProviderState {
  inStock: { [code: string]: boolean };
  isLoading: boolean;
  isError: boolean;
}

class StockDataProvider extends PureComponent<StockDataProviderProps, StockDataProviderState> {
  state = {
    inStock: {},
    isLoading: false,
    isError: false,
  };

  getInstockMap = (data: AvailabilityInfo[]) => {
    const map: Record<string, boolean> = {};
    data.forEach((item) => (map[item.code] = selectProductIsInStock(item)));
    return map;
  };

  loadData = (products: PreferredProductData[]) => {
    this.setState({
      inStock: {},
      isLoading: true,
      isError: false,
    });

    const codes = products.map((product) => product.code);

    Promise.all(codes.map((code) => requestAvailabilityDataSingle({ productCode: code })))
      .then((data) => this.setState({ isLoading: false, inStock: this.getInstockMap(data) }))
      .catch(() => this.setState({ isLoading: false, isError: true }));
  };

  componentDidMount() {
    this.loadData(this.props.products);
  }

  componentWillReceiveProps(newProps: StockDataProviderProps) {
    if (this.props.products !== newProps.products) {
      this.loadData(newProps.products);
    }
  }

  render() {
    return this.props.children(this.state);
  }
}

export default StockDataProvider;
